export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-4-4966ac937614e5e2487f35d65a0c9546.webp";